import React, { useState, useEffect } from 'react';
import firebase from 'firebase';
import styled from 'styled-components';
import { nanoid } from 'nanoid';

const UserContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	background-color: ${(props) => (props.odd ? ' #ffffff' : '#f1f1f1')};
	width: 100%;
	height: 40px;
`;

const UserItemContent = styled.div`
	display: flex;
	align-items: center;
	max-width: 400px;
	width: 100%;
`;

const UserItem = ({ userId, odd }) => {
	const [ userData, setUserData ] = useState('');
	const db = firebase.firestore();

	const fetchData = async () => {
		const ref = await db.collection('users').doc(userId.id).collection('code').doc('secret').get();

		console.log('ref', ref.data());
		setUserData(ref.data());
	};

	const generateUid = async () => {
		const ref = await db
			.collection('users')
			.doc(userId.id)
			.collection('code')
			.doc('secret')
			.set({ code: nanoid(12) });

		fetchData();
	};

	useEffect(() => {
		fetchData();
	}, []);
	return (
		<UserContainer odd={odd}>
			<UserItemContent>{userId.email}</UserItemContent>
			<UserItemContent>{userData && userData.code}</UserItemContent>
			<button onClick={() => generateUid()}>New code</button>
		</UserContainer>
	);
};

export default UserItem;
